export const getCurrentSeriesPositionIndex = (seriesId, series, currentPage, pageSize) => {
    const index = series.findIndex((series) => series.id === seriesId) + 1;
    return pageSize * (currentPage - 1) + index;
};
export const getUpdatedSeriesPositionIndex = (type, updatedIndex, totalSeriesCount) => {
    return {
        TOP: 0,
        BOTTOM: totalSeriesCount - 1,
        EXACT: updatedIndex - 1,
    }[type];
};
